// extracted by mini-css-extract-plugin
export var actionButton = "_7v-1";
export var actionButtons = "_7v-2";
export var actions = "_7v-0";
export var aiUnread = "_7v-10";
export var alignCenter = "_7v-h";
export var backWrapper = "_7v-3";
export var cellContainer = "_7v-4";
export var checkboxContainer = "_7v-5";
export var contentContainer = "_7v-6";
export var contentHeader = "_7v-8";
export var conversationsTableWrapper = "_7v-s";
export var draftReplyBadgeContainer = "_7v-m";
export var dropdownItem = "_7v-b";
export var dropdownItemsContainer = "_7v-a";
export var dropdownTitle = "_7v-c";
export var errorIcon = "_7v-7";
export var filter = "_7v-d";
export var gray = "_7v-i";
export var headerActionButtons = "_7v-e";
export var headerCheckboxContainer = "_7v-f";
export var icon = "_7v-j";
export var menuContainer = "_7v-k";
export var noMoreTicketsIcon = "_7v-12";
export var noMoreTicketsSubText = "_7v-13";
export var oneLine = "_7v-l";
export var optionsButton = "_7v-n";
export var plus = "_7v-o";
export var portalButtonsWrapper = "_7v-g";
export var red = "_7v-p";
export var scrolledTop = "_7v-9";
export var search = "_7v-q";
export var selectedConversationsCount = "_7v-r";
export var spinner = "_7v-t";
export var strong = "_7v-u";
export var summaryCell = "_7v-v";
export var tableContainer = "_7v-11";
export var tagContainer = "_7v-w";
export var threeDots = "_7v-x";
export var twoLines = "_7v-y";
export var unread = "_7v-z";